export default __webpack_public_path__ + "static/homepage-hero-5de78fe562723c2e8198ffc3c953ce8d.png";